import { render, staticRenderFns } from "./PopupNAPConsultationApplication.vue?vue&type=template&id=5483edb7&scoped=true"
import script from "./PopupNAPConsultationApplication.vue?vue&type=script&lang=js"
export * from "./PopupNAPConsultationApplication.vue?vue&type=script&lang=js"
import style0 from "./PopupNAPConsultationApplication.vue?vue&type=style&index=0&id=5483edb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483edb7",
  null
  
)

export default component.exports